import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';
import { MuiAlert } from './alert';
import { MuiAutocomplete } from './autocomplete';
import { MuiAvatar } from './avatar';
import { MuiBackdrop } from './backdrop';
import { MuiBadge } from './badge';
import { MuiButton } from './button';
import { MuiButtonBase } from './button-base';
import { MuiButtonGroup } from './button-group';
import { MuiCard, MuiCardActions, MuiCardContent, MuiCardHeader } from './card';
import { MuiCheckbox } from './checkbox';
import { MuiChip } from './chip';
import { MuiDialog, MuiDialogActions, MuiDialogContent, MuiDialogTitle } from './dialog';
import { MuiDrawer } from './drawer';
import { MuiIconButton } from './icon-button';
import {
  MuiFilledInput,
  MuiFormControlLabel,
  MuiFormGroup,
  MuiFormLabel,
  MuiInput,
  MuiInputBase,
  MuiInputLabel,
  MuiTextField,
  MuiTimelineConnector,
} from './input';
import { MuiLinearProgress } from './linear-progress';
import { MuiLink } from './link';
import {
  MuiList,
  MuiListItem,
  MuiListItemAvatar,
  MuiListItemButton,
  MuiListItemIcon,
  MuiListItemText,
} from './list';
import { MuiMenu, MuiMenuItem } from './menu';
import { MuiOutlinedInput } from './outlined-input';
import { MuiPaper } from './paper';
import { MuiPopover } from './popover';
import { MuiRadio } from './radio';
import { MuiSelect } from './select';
import { MuiStack } from './stack';
import { MuiStep, MuiStepConnector, MuiStepIcon, MuiStepLabel, MuiStepper } from './stepper';
import { MuiSwitch } from './switch';
import { MuiTab, MuiTabs } from './tabs';
import { MuiTableBody, MuiTableCell, MuiTableHead, MuiTablePagination } from './table';
import { MuiToggleButton, MuiToggleButtonGroup } from './toggle-button';
import { MuiTooltip } from './tooltip';

export const components = {
  MuiAlert,
  MuiAutocomplete,
  MuiAvatar,
  MuiBackdrop,
  MuiBadge,
  MuiButton,
  MuiButtonBase,
  MuiButtonGroup,
  MuiCard,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiCheckbox,
  MuiChip,
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogTitle,
  MuiDrawer,
  MuiFilledInput,
  MuiFormControlLabel,
  MuiFormGroup,
  MuiFormLabel,
  MuiIconButton,
  MuiInput,
  MuiInputBase,
  MuiInputLabel,
  MuiLinearProgress,
  MuiLink,
  MuiList,
  MuiListItem,
  MuiListItemAvatar,
  MuiListItemButton,
  MuiListItemIcon,
  MuiListItemText,
  MuiMenu,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaper,
  MuiPopover,
  MuiRadio,
  MuiSelect,
  MuiStack,
  MuiStep,
  MuiStepConnector,
  MuiStepIcon,
  MuiStepLabel,
  MuiStepper,
  MuiSwitch,
  MuiTab,
  MuiTableBody,
  MuiTableCell,
  MuiTableHead,
  MuiTablePagination,
  MuiTabs,
  MuiTextField,
  MuiTimelineConnector,
  MuiToggleButton,
  MuiToggleButtonGroup,
  MuiTooltip,
} satisfies Components<Theme>;

// Re-export individual components for selective use
export { MuiAlert } from './alert';
export { MuiAutocomplete } from './autocomplete';
export { MuiAvatar } from './avatar';
export { MuiBackdrop } from './backdrop';
export { MuiBadge } from './badge';
export { MuiButton } from './button';
export { MuiButtonBase } from './button-base';
export { MuiButtonGroup } from './button-group';
export { MuiCard, MuiCardActions, MuiCardContent, MuiCardHeader } from './card';
export { MuiCheckbox } from './checkbox';
export { MuiChip } from './chip';
export { MuiDialog, MuiDialogActions, MuiDialogContent, MuiDialogTitle } from './dialog';
export { MuiDrawer } from './drawer';
export { MuiIconButton } from './icon-button';
export {
  MuiFilledInput,
  MuiFormControlLabel,
  MuiFormGroup,
  MuiFormLabel,
  MuiInput,
  MuiInputBase,
  MuiInputLabel,
  MuiTextField,
  MuiTimelineConnector,
} from './input';
export { MuiLinearProgress } from './linear-progress';
export { MuiLink } from './link';
export {
  MuiList,
  MuiListItem,
  MuiListItemAvatar,
  MuiListItemButton,
  MuiListItemIcon,
  MuiListItemText,
} from './list';
export { MuiMenu, MuiMenuItem } from './menu';
export { MuiOutlinedInput } from './outlined-input';
export { MuiPaper } from './paper';
export { MuiPopover } from './popover';
export { MuiRadio } from './radio';
export { MuiSelect } from './select';
export { MuiStack } from './stack';
export { MuiStep, MuiStepConnector, MuiStepIcon, MuiStepLabel, MuiStepper } from './stepper';
export { MuiSwitch } from './switch';
export { MuiTab, MuiTabs } from './tabs';
export { MuiTableBody, MuiTableCell, MuiTableHead, MuiTablePagination } from './table';
export { MuiToggleButton, MuiToggleButtonGroup } from './toggle-button';
export { MuiTooltip } from './tooltip';
